import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../styles/styles-css-variables";

export const StepProgress: ReactTFC<{ progress: { percent: number } }> = props => {
  return (
    <div
      css={css`
        position: absolute;
        top: 0;

        width: calc(100% + 2 * var(--content-gutter));
        left: calc(-1 * var(--content-gutter));

        --h: 8px;
        height: var(--h);

        z-index: 2;
        background-color: ${CSS_COLORS.GreenWhite};
      `}
    >
      <span
        style={{ width: `${props.progress.percent}%` }}
        css={css`
          transition: 0.3s linear width;

          background-color: ${CSS_COLORS.Green};
          width: 1%;
          max-width: 100%;

          height: var(--h);
          display: block;

          border-top-right-radius: calc(0.5 * var(--h));
          border-bottom-right-radius: calc(0.5 * var(--h));
        `}
      />
    </div>
  );
};
